export enum CalendarEntryType {
  Event = 'event',
  Reminder = 'reminder',
  Task = 'task',
}

export interface GenericCalendarEntry {
  id: string;
  name: string;
  startDate: number;
  endDate?: number;
  type: CalendarEntryType;
  userId: string;
  propertyId: string;
  createdAt: number;
  updatedAt: number;
}

export type CalendarEvent = GenericCalendarEntry & {
  type: CalendarEntryType.Event;
};

export interface CreateCalendarEvent {
  name: string;
  startDate: number;
  endDate: number;
}

export interface UpdateCalendarEvent {
  name?: string;
  startDate?: number;
  endDate?: number;
}

export type CalendarReminder = GenericCalendarEntry & {
  type: CalendarEntryType.Reminder;
};

export interface CreateCalendarReminder {
  name: string;
  startDate: number;
}

export interface UpdateCalendarReminder {
  name?: string;
  startDate?: number;
}
